(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  L.Control.MFDraw = (function(superClass) {
    extend(MFDraw, superClass);

    function MFDraw() {
      this.handleClick = bind(this.handleClick, this);
      this.toggleButton = bind(this.toggleButton, this);
      return MFDraw.__super__.constructor.apply(this, arguments);
    }

    MFDraw.prototype.options = {
      position: 'topleft',
      toolbars: [
        {
          rows: [
            [
              {
                name: 'draw-poly-add',
                html: '<i class="drawicon-poly-green"></i>',
                toggle: true
              }, {
                name: 'draw-poly-sub',
                html: '<i class="drawicon-poly-red"></i>',
                toggle: true
              }
            ], [
              {
                name: 'draw-rect-add',
                html: '<i class="drawicon-rect-green"></i>',
                toggle: true
              }, {
                name: 'draw-rect-sub',
                html: '<i class="drawicon-rect-red"></i>',
                toggle: true
              }
            ], [
              {
                name: 'draw-circle-add',
                html: '<i class="drawicon-circle-green"></i>',
                toggle: true
              }, {
                name: 'draw-circle-sub',
                html: '<i class="drawicon-circle-red"></i>',
                toggle: true
              }
            ]
          ]
        }, {
          style: {
            width: '29px'
          },
          rows: [
            [
              {
                name: 'draw-select',
                html: '<i class="fa fa-hand-o-up"></i>',
                toggle: true
              }
            ], [
              {
                name: 'draw-delete',
                html: '<i class="fa fa-trash-alt"></i>',
                toggle: true
              }
            ], [
              {
                name: 'draw-undo',
                html: '<i class="fa fa-reply"></i>',
                toggle: false
              }
            ]
          ]
        }
      ]
    };

    MFDraw.prototype.onAdd = function(map) {
      var btn, container, dataName, drawControl, j, l, len, len1, len2, m, nbtn, ref, ref1, ref2, row, self, tb, txt, v;
      this.callbacks = {};
      this.buttons = {};
      this.outerContainer = L.DomUtil.create('div');
      self = this;
      this._map = map;
      ref = this.options.toolbars;
      for (j = 0, len = ref.length; j < len; j++) {
        tb = ref[j];
        drawControl = 'leaflet-control-mfdraw';
        container = L.DomUtil.create('div', drawControl + " leaflet-bar", this.outerContainer);
        if (tb.style != null) {
          $(container).css(tb.style);
        }
        ref1 = tb.rows;
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          v = ref1[l];
          row = this._addRow(container);
          for (m = 0, len2 = v.length; m < len2; m++) {
            btn = v[m];
            txt = (ref2 = btn.html) != null ? ref2 : btn.name;
            dataName = btn.name;
            this.callbacks[dataName] = [];
            nbtn = L.DomUtil.create('a', "clickable " + dataName + " pull-left", row);
            nbtn.innerHTML = "" + txt;
            $(nbtn).data('drawName', dataName);
            this.buttons[dataName] = $(nbtn);
            $(nbtn).on('mouseenter', function(e) {
              return $('.leaflet-draw-tooltip').hide();
            });
            $(nbtn).on('mouseleave', function(e) {
              return $('.leaflet-draw-tooltip').show();
            });
            $(nbtn).on('click', function(e) {
              e.preventDefault();
              if ($(e.currentTarget).hasClass('leaflet-mfdraw-disabled')) {
                return;
              }
              self.handleClick($(e.currentTarget).data('drawName'), e);
              return false;
            });
            if ((btn.toggle != null) && btn.toggle) {
              this.addCallback(dataName, function(e, drawname) {
                return self.toggleButton(drawname);
              });
            } else {
              this.addCallback(dataName, function(e, drawname) {
                return self.toggleButton(drawname, false);
              });
            }
          }
        }
      }
      return this.outerContainer;
    };

    MFDraw.prototype.toggleButton = function(btn, select) {
      if (select == null) {
        select = true;
      }
      this.deselectAllButtons();
      if (select) {
        return this.selectBtn(btn);
      }
    };

    MFDraw.prototype.getButton = function(btn) {
      return this.buttons[btn];
    };

    MFDraw.prototype.selectBtn = function(btn) {
      var button;
      button = this.buttons[btn];
      return button.addClass('leaflet-mfdraw-active');
    };

    MFDraw.prototype.deselectBtn = function(btn) {
      var button;
      button = this.buttons[btn];
      return button.removeClass('leaflet-mfdraw-active');
    };

    MFDraw.prototype.deselectAllButtons = function() {
      var k, results, self;
      self = this;
      results = [];
      for (k in this.buttons) {
        results.push(this.deselectBtn(k));
      }
      return results;
    };

    MFDraw.prototype.disableBtn = function(btn) {
      var btns, button, i, j, len, results;
      btns = this._parseButtonSelector(btn);
      results = [];
      for (j = 0, len = btns.length; j < len; j++) {
        i = btns[j];
        button = this.buttons[i];
        this.deselectBtn(i);
        results.push(button.addClass('leaflet-mfdraw-disabled'));
      }
      return results;
    };

    MFDraw.prototype.enableBtn = function(btn) {
      var btns, button, i, j, len, results;
      btns = this._parseButtonSelector(btn);
      results = [];
      for (j = 0, len = btns.length; j < len; j++) {
        i = btns[j];
        button = this.buttons[i];
        results.push(button.removeClass('leaflet-mfdraw-disabled'));
      }
      return results;
    };

    MFDraw.prototype._parseButtonSelector = function(sel) {
      var i, j, k, len, multi, ref, result, v;
      result = [];
      if (sel === '*') {
        ref = this.buttons;
        for (k in ref) {
          v = ref[k];
          result.push(k);
        }
      } else {
        multi = sel.split(',');
        for (j = 0, len = multi.length; j < len; j++) {
          i = multi[j];
          result.push(i);
        }
      }
      return result;
    };

    MFDraw.prototype.handleClick = function(name, e) {
      var i, j, len, ref, results;
      ref = this.callbacks[name];
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        i = ref[j];
        results.push(i(e, name, this.outerContainer));
      }
      return results;
    };

    MFDraw.prototype.addCallback = function(dataName, cb) {
      var btn, i, j, len;
      btn = this._parseButtonSelector(dataName);
      for (j = 0, len = btn.length; j < len; j++) {
        i = btn[j];
        this.callbacks[i].push(cb);
      }
      return cb;
    };

    MFDraw.prototype.removeCallback = function(dataName, cb) {
      var ind;
      ind = this.callbacks[dataName].indexOf(cb);
      if (ind !== -1) {
        return this.callbacks[dataName].splice(ind, 1);
      }
    };

    MFDraw.prototype._addRow = function(container) {
      var row;
      row = L.DomUtil.create('div', 'leaflet-mfdraw-row', container);
      return row;
    };

    return MFDraw;

  })(L.Control);

}).call(this);
